import { useEffect } from "react";

/**
 * Site-wide SEO meta injection (runs once on mount).
 * Adds Google Search Console + Bing Webmaster verification tags,
 * default OG/Twitter defaults, and the Organization + WebSite JSON-LD.
 * Uses env vars so users can drop tokens in without code changes:
 *   REACT_APP_GSC_VERIFICATION  → <meta name="google-site-verification" content="...">
 *   REACT_APP_BING_VERIFICATION → <meta name="msvalidate.01" content="...">
 */
export default function SiteMeta() {
  useEffect(() => {
    const gsc = process.env.REACT_APP_GSC_VERIFICATION;
    const bing = process.env.REACT_APP_BING_VERIFICATION;

    const ensure = (name, content) => {
      if (!content) return;
      let el = document.head.querySelector(`meta[name="${name}"]`);
      if (!el) { el = document.createElement("meta"); el.setAttribute("name", name); document.head.appendChild(el); }
      el.setAttribute("content", content);
    };

    ensure("google-site-verification", gsc);
    ensure("msvalidate.01", bing);

    // Global JSON-LD once (individual pages add their own via SEO component)
    if (!document.getElementById("global-jsonld")) {
      const script = document.createElement("script");
      script.type = "application/ld+json";
      script.id = "global-jsonld";
      const origin = typeof window !== "undefined" ? window.location.origin : "";
      script.text = JSON.stringify([
        {
          "@context": "https://schema.org",
          "@type": "Organization",
          name: "ImageKitHub",
          url: origin,
          logo: `${origin}/icons/icon-512.png`,
          sameAs: [],
          description: "Free, private, browser-based image tools.",
        },
        {
          "@context": "https://schema.org",
          "@type": "WebSite",
          name: "ImageKitHub",
          url: origin,
          potentialAction: {
            "@type": "SearchAction",
            target: `${origin}/tools?q={search_term_string}`,
            "query-input": "required name=search_term_string",
          },
        },
      ]);
      document.head.appendChild(script);
    }
  }, []);
  return null;
}
